const STORAGE_PREFIX = 'salesgod:'

export const storage = {
  get<T>(key: string, fallback: T): T {
    try {
      const raw = localStorage.getItem(`${STORAGE_PREFIX}${key}`)
      return raw ? (JSON.parse(raw) as T) : fallback
    } catch {
      return fallback
    }
  },

  set<T>(key: string, value: T): void {
    localStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(value))
  },

  remove(key: string): void {
    localStorage.removeItem(`${STORAGE_PREFIX}${key}`)
  },
}
